"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRibbonStyles = exports.ribbonVars = exports.ribbonCommonProps = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var ribbonCommonProps = exports.ribbonCommonProps = _commonProps.defaultCommonProps;
var ribbonVars = exports.ribbonVars = (0, _initVars.default)({
  applied: ribbonCommonProps,
  variables: [{
    key: "backgroundColor",
    canHaveColor: true
  }, {
    key: "transform"
  }, {
    key: "color"
  }, {
    key: "ribbonFontSize",
    defaultUnit: "px"
  }]
});
var styles = function styles(theme) {
  var spacing = theme.spacing,
    colors = theme.colors,
    typography = theme.typography;
  return {
    variables: ribbonVars.styles,
    root: {
      display: "inline-block",
      position: "relative"
    },
    ribbonWrapper: {
      position: "absolute",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      pointerEvents: "none"
    },
    ribbon: {
      boxSizing: "content-box",
      backgroundColor: ribbonVars.get("backgroundColor"),
      boxShadow: "0 1px 2px 0 ".concat((0, _getRgbaFromHex.default)(colors.baseShadow, 0.5)),
      color: ribbonVars.get("color"),
      fontSize: ribbonVars.get("ribbonFontSize", typography.fontSize + 6),
      fontWeight: 600,
      fontFamily: typography.fontFamily,
      padding: spacing.base,
      position: "absolute",
      textAlign: "center",
      textTransform: "uppercase",
      transform: ribbonVars.get("transform"),
      width: 200,
      zIndex: 1
    }
  };
};
var useRibbonStyles = exports.useRibbonStyles = (0, _createUseStyles.default)(styles, {
  name: "Ribbon"
});